import React, { useEffect } from 'react';
import { useParams } from 'react-router';

function ReferralCode() {
  const params = useParams();
  const { referralCode } = params;

  useEffect(() => {
    window.location.assign(
      `${import.meta.env.VITE_APP_REFERRAL_URL}?utm_source=policymogul-referral&utm_medium=referrer&utm_campaign=${referralCode}`
    );
  }, []);

  return <div>Redirection...</div>;
}

export default ReferralCode;
